import { render, staticRenderFns } from "./FileTextOutlinedIcon.vue?vue&type=template&id=2349ac05&scoped=true"
import script from "./FileTextOutlinedIcon.vue?vue&type=script&lang=js"
export * from "./FileTextOutlinedIcon.vue?vue&type=script&lang=js"
import style0 from "./FileTextOutlinedIcon.vue?vue&type=style&index=0&id=2349ac05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2349ac05",
  null
  
)

export default component.exports